/** A link to a bank data aggregator. Today only SimpleFIN Bridge (https://beta-bridge.simplefin.org). */
export type BankProvider = 'simplefin';

/** `revoked`: the access was disabled at the provider, so the user has to connect again. */
export type BankConnectionStatus = 'active' | 'error' | 'revoked';

/** What an account is, which decides how its transactions count. SimpleFIN doesn't say, so it is guessed. */
export type BankAccountKind = 'checking' | 'savings' | 'credit' | 'investment' | 'loan' | 'other';

export const BANK_ACCOUNT_KINDS: BankAccountKind[] = ['checking', 'savings', 'credit', 'investment', 'loan', 'other'];

export interface BankAccount {
  id: string;
  connectionId: string;
  institution: string | null;
  name: string;
  currency: string;
  balance: number | null;
  availableBalance: number | null;
  balanceDate: string | null;
  kind: BankAccountKind;
  hidden: boolean;
  /** The transactions held for the account: how many, and the dates they span. */
  transactionCount: number;
  firstTransactionDate: string | null;
  lastTransactionDate: string | null;
}

export interface BankConnection {
  id: string;
  provider: BankProvider;
  status: BankConnectionStatus;
  /** True while a sync runs, including the first one that walks back through history. */
  syncing: boolean;
  historySynced: boolean;
  lastSyncAt: string | null;
  lastError: string | null;
  createdAt: string;
  accounts: BankAccount[];
}
